import {FormView} from '../../src/components/_views/configurable/FormView';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';
import ClientForm from './ClientForm';

export class ClientUpdateForm extends FormView {
    protected getFormComponent() {
        return ClientForm;
    }
}

export default ClientUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(ClientUpdateForm));
